<template>
  <v-container>
    <h1>Umfrage Statistiken</h1>
    <Pending v-model="statsPromise">
      <v-expansion-panels class="mt-8">
        <v-expansion-panel
          v-for="(stat, i) in stats"
          :key="i"
        >
          <v-expansion-panel-header>
            <div class="stat-header">
              <div class="stat-label">
                {{ stat.client.name }}<br>
                <small>{{ stat.survey.title }}</small>
              </div>
              <div class="stat-bar">
                <div class="bar-values">
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <span class="primary-value" v-bind="attrs" v-on="on">
                        {{ stat.surveys_finished.percentage_of_tokens_generated.toFixed(1) }}% abgeschlossen
                      </span>
                    </template>
                    {{ stat.surveys_finished.count }} von {{ stat.tokens_generated }} abgeschlossen
                  </v-tooltip>
                  |
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <span class="secondary-value" v-bind="attrs" v-on="on">
                        {{ stat.surveys_started.percentage_of_tokens_generated.toFixed(1) }}% begonnen
                      </span>
                    </template>
                    {{ stat.surveys_started.count }} von {{ stat.tokens_generated }} begonnen
                  </v-tooltip>
                  |
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <span class="bg-value" v-bind="attrs" v-on="on">
                        {{ 100 - stat.surveys_started.percentage_of_tokens_generated.toFixed(1) }}% nicht begonnen
                      </span>
                    </template>
                    {{ stat.tokens_generated - stat.surveys_started.count }} von {{ stat.tokens_generated }} nicht begonnen
                  </v-tooltip>
                </div>

                <div class="bar-track" v-bind="attrs" v-on="on">
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <div class="bar bar-bg" v-bind="attrs" v-on="on" />
                    </template>
                    {{ stat.tokens_generated - stat.surveys_started.count }} von {{ stat.tokens_generated }} nicht begonnen
                  </v-tooltip>
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <div
                        class="bar bar-secondary"
                        :style="{width: stat.surveys_started.percentage_of_tokens_generated.toFixed(1) + '%'}"
                        v-bind="attrs"
                        v-on="on"
                      />
                    </template>
                    {{ stat.surveys_started.count }} von {{ stat.tokens_generated }} begonnen
                  </v-tooltip>
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <div
                        class="bar bar-primary"
                        :style="{width: stat.surveys_finished.percentage_of_tokens_generated.toFixed(1) + '%'}"
                        v-bind="attrs"
                        v-on="on"
                      />
                    </template>
                    {{ stat.surveys_finished.count }} von {{ stat.tokens_generated }} abgeschlossen
                  </v-tooltip>
                </div>
              </div>
            </div>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-simple-table dense>
              <template v-slot:default>
                <tbody>
                  <tr>
                    <td>Klinik</td>
                    <td>{{ stat.client.name }}</td>
                  </tr>
                  <tr>
                    <td>Befragung</td>
                    <td>{{ stat.survey.title }}</td>
                  </tr>
                  <tr>
                    <td>Anzahl der Fragen</td>
                    <td v-if="stat.survey.question_count.min === stat.survey.question_count.max">{{ stat.survey.question_count.min }}</td>
                    <td v-else>{{ stat.survey.question_count.min }} - {{ stat.survey.question_count.max }} Fragen</td>
                  </tr>
                  <tr>
                    <td>Zugangscodes Gesamtanzahl</td>
                    <td>{{ stat.tokens_generated }}</td>
                  </tr>
                  <tr>
                    <td>Zugangscodes aktiviert</td>
                    <td>{{ stat.tokens_activated.count }} ({{ stat.tokens_activated.percentage_of_tokens_generated.toFixed(1) }}%)</td>
                  </tr>
                  <tr>
                    <td>Befragungen begonnen</td>
                    <td>{{ stat.surveys_started.count }} ({{ stat.surveys_started.percentage_of_tokens_generated.toFixed(1) }}%)</td>
                  </tr>
                  <tr>
                    <td>Befragungen abgeschlossen</td>
                    <td>{{ stat.surveys_finished.count }} ({{ stat.surveys_finished.percentage_of_tokens_generated.toFixed(1) }}%)</td>
                  </tr>
                  <tr>
                    <td>Mittlere Anzahl Antworten<br><small> (bei {{ stat.surveys_started.count }} begonnenen Befragungen) </small></td>
                    <td>
                      {{ stat.questions_answered.average_count.toFixed(1) }} Antworten
                    </td>
                  </tr>
                  <tr>
                    <td>Mittlere Antwortrate<br><small> (bei {{ stat.surveys_started.count }} begonnenen Befragungen) </small></td>
                    <td>
                      <span v-if="stat.questions_answered.average_percentage_min === stat.questions_answered.average_percentage_max">
                        {{ stat.questions_answered.average_percentage_min.toFixed(1) }}% Antwortrate
                      </span>
                      <span v-else>
                        zwischen {{ stat.questions_answered.average_percentage_min.toFixed(1) }}% und {{ stat.questions_answered.average_percentage_max.toFixed(1) }}%
                      </span>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </Pending>
  </v-container>
</template>

<script>
import axios from 'axios'

export default {
  name: 'SurveyStats',
  components: {
  },
  data: () => ({
    panel: null,
    pending: false,
    statsPromise: null,
    stats: [],
  }),
  computed: {
  },
  watch: {
    availableIndications(val) {
      const availableIndicationIds = []
      val.forEach(indication => {
        availableIndicationIds.push(indication.id)
      })
      const c = [...this.selectedIndications]
      c.forEach(indication => {
        if (!availableIndicationIds.includes(indication.id)) {
          this.selectedIndications.splice(this.selectedIndications.indexOf(indication), 1)
        }
      })
    },
  },
  created() {
    this.fetchStats()
  },
  methods: {
    fetchStats() {
      this.statsPromise = axios.get(this.$store.state.apiPath + '/survey-access/stats')
      this.statsPromise.then(response => {
        this.stats = response.data
      })
    },
  }
}
</script>

<style scoped>

  .stat-header {
    margin-right: 1em;
    display: flex;
    align-items: center;
  }

  .stat-label {
    width: 40%;
    font-size: 14px;
    color: #333;
  }

  .stat-bar {
    width: 60%;
  }

  .bar-values {
    display: flex;
    gap: 8px;
    margin-bottom: 5px;
    font-size: 12px;
    font-weight: bold;
  }

  .bg-value {
    color: #989898;
  }

  .primary-value {
    color: #023465;
  }

  .secondary-value {
    color: #527795;
  }

  .bar-track {
    width: 100%;
    height: 18px;
    background-color: #e9edf1;
    border-radius: 3px;
    overflow: hidden;
    position: relative;
  }

  .bar {
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    border-radius: 3px;
  }

  .bar-bg {
    background-color: #e9edf1;
    width: 100%;
    z-index: 1;
  }

  .bar-secondary {
    background-color: #8ba9c2;
    z-index: 2;
  }

  .bar-primary {
    background-color: #023465;
    z-index: 3;
  }
</style>